import LandingPageShell from "@/components/landing-page/layout/LandingPageShell";
import HeroCoverTransition from "@/components/landing-page/home/HeroCoverTransition";
import TrustedBy from "@/components/landing-page/home/TrustedBy";
import TheProblem from "@/components/landing-page/home/TheProblem";
import InaraXDifference from "@/components/landing-page/home/InaraXDifference";
import WhyNotChatGpt from "@/components/landing-page/home/WhyNotChatGpt";
import EnterpriseScale from "@/components/landing-page/home/EnterpriseScale";

export default function Home() {
  return (
    <LandingPageShell>
      <HeroCoverTransition>
        <TrustedBy />
        <TheProblem />
      </HeroCoverTransition>
      <InaraXDifference />
      <WhyNotChatGpt />
      <EnterpriseScale />
    </LandingPageShell>
  );
}
